import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useChatterList } from '../hooks/useChatterList'
import OpportunityListItem from './OpportunityListItem'
import styles from '../styles/ChatterSidebarLayout.module.css'

interface ChatterSidebarLayoutProps {
  children: React.ReactNode
  selectedOpportunityId?: string
}

const ChatterSidebarLayout: React.FC<ChatterSidebarLayoutProps> = ({ 
  children, 
  selectedOpportunityId 
}) => {
  const navigate = useNavigate()
  const {
    conversations,
    loading,
    error,
    unreadCount,
    refreshConversations
  } = useChatterList()

  const handleOpportunitySelect = (opportunityId: string) => {
    navigate(`/chatter/${opportunityId}`)
  }

  return (
    <div className={styles.chatterLayout}>
      {/* Opportunities Sidebar */}
      <div className={styles.opportunitiesSidebar}>
        <div className={styles.opportunitiesHeader}>
          <div className={styles.headerTitle}>
            <h2>My Chatter</h2>
            {unreadCount > 0 && (
              <span className={styles.unreadBadge}>{unreadCount}</span>
            )}
          </div>
          <button 
            onClick={refreshConversations}
            className={styles.refreshButton}
            title="Refresh conversations"
            disabled={loading}
          >
            <i className={`bi bi-arrow-clockwise `}>refresh</i>
          </button>
        </div>

        <div className={styles.opportunitiesList}>
          {loading ? (
            <div className={styles.loadingState}>
              <div className={styles.loadingSpinner}></div>
              <p>Loading conversations...</p>
            </div>
          ) : error ? (
            <div className={styles.errorState}>
              <p>Error loading conversations</p>
              <button onClick={refreshConversations} className={styles.retryButton}>
                Retry
              </button>
            </div>
          ) : conversations.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>💬</div>
              <h3>No conversations yet</h3>
              <p>When clients send you messages about your deals, they'll appear here.</p>
            </div>
          ) : (
            conversations.map((conversation) => (
              <OpportunityListItem
                key={conversation.opportunityId}
                conversation={conversation}
                isSelected={selectedOpportunityId === conversation.opportunityId}
                onClick={() => handleOpportunitySelect(conversation.opportunityId)}
              />
            ))
          )}
        </div>
      </div>

      {/* Main Content Area */}
      <div className={styles.mainContent}>
        {children}
      </div>
    </div>
  )
}

export default ChatterSidebarLayout
